import router from './routers'
import { dynamicRouterAdd } from '@/utils/router-utils'
import store from './store'
import { message } from 'ant-design-vue'
import { sendUserInfo } from '@/api/login';
import { getMenu } from "@/api/public";
import { iscode } from './utils/app';
//转化当前用户导航菜单权限tree为一维数组list
const getMenuList = (menuTree, menuList) => {
  for (let i = 0; i < menuTree.length; i++) {
    if (menuTree[i].component) {
      menuList.push(menuTree[i])
    }
    if (menuTree[i].children && menuTree[i].children.length > 0) {
      getMenuList(menuTree[i].children, menuList);
    }
  }
};
//获取当前用户所有可以访问的路由权限
const getRoutes = (routeList, menuTree) => {
  let menuList = [];
  getMenuList(menuTree, menuList);
  return menuList.map(v => {
    let route = routeList.find(r => r.path === v.url);
    return route ? route : false;
  }).filter(v => !!v);
};
// 递归处理成一个数据集合
const rulesHandle = (data, list) => {

  data.forEach(element => {
    list.push(element.auth)
    if (element.children && element.children.length) {
      rulesHandle(element.children, list)
    }
  });
  return list
}
const whiteList = ['/login', '/forgetpasswordone', '/forgetpasswordtwo', '/forgetpasswordtwo/phoneverification', '/forgetpasswordtwo/qrcodeverification'] // no redirect whitelist
const appMarkList = {
  "integralShop":12, //积分商城
  "onlineOrder":9, //在线订货
  "guide":7, //超级导购
  "antiFleeingGoods":6, //智能防窜
  "marketing":5, //智能营销
  "messageCenter":1, //消息管理
  "qrcode":4, //二维码管理
}
router.beforeEach(async (to, from, next) => {
  const userToken = localStorage.getItem('token');
  if (userToken) {
    if(from.query.redict_url){
      location.href=from.query.redict_url+'?token='+userToken
    }
    if(to.query.authorization_url){
      window.location.href = to.query.authorization_url+'&component_appid='+to.query.component_appid+'&redirect_uri='+location.href.split("/?authorization_url")[0]
      localStorage.setItem("ydhz_url", to.query.redirect_uri);
    }
    if(localStorage.getItem('ydhz_url')&&to.query.auth_code&&to.path === '/index'){
      location.href = localStorage.getItem('ydhz_url')+'?auth_code='+to.query.auth_code
      setTimeout(() => {
        localStorage.removeItem("ydhz_url")
      },0)
    }
    // 有token
    // 路径为登录页则跳转到首页
    if (to.path === '/login') {
      next({ path: '/index' })
    } else {
      let userInfo = store.state.user.info;
      if (userInfo && userInfo.menu && userInfo.menu.length > 0) {
        next()
      } else {
        try {
          var pathAuth = to.path.split('/')[1]
          let result = await getMenu({app_id:appMarkList[pathAuth]?appMarkList[pathAuth]:0}).then((res) => res.data).catch((error) => error);
          if (iscode(result)) {
            if (!result.data.length) {
              message.error("对不起该角色暂无任何权限！");
              localStorage.removeItem("token")
              next(`/login`)
              return;
            }
            let res = await sendUserInfo().then(res => res.data).catch(error => error)
            if (iscode(res)) {
              // 权限集合
              var info = {
                ...res.data,
                menu: result.data,
                picdomain: res.data.overView.picdomain,
                brand_mark:res.data.overView.brand_mark
              }
              if(info.picdomain.indexOf('http')==-1){
                info.picdomain='http:'+info.picdomain
              }
              info.auths = rulesHandle(info.menu, []).filter((x) => x !== '')
              store.dispatch('user/setUserInfo', info);
              store.dispatch('user/setUserMenu', { menu: info.menu[0] });
              let routesMap = getRoutes(dynamicRouterAdd(), info.menu)
              router.$addRoutes(routesMap);
              next({ ...to, replace: true })
            } else {
              localStorage.removeItem("token")
              next(`/login`)
            }
          }else{
            localStorage.removeItem("token")
            next(`/login`)
          }
        } catch (error) {
          message.error(error || 'Has Error')
          localStorage.removeItem("token")
          next(`/login`)
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login`)
    }
  }
})

router.afterEach(async (to) => {
  // finish progress bar
  if (to.path === '/login') {
    // 跳转登录页清除仓库用户信息，token取自localStorage，需要先行删除
    await store.dispatch('user/setUserToken', '');
    await store.dispatch('user/setUserInfo', null);
    await store.dispatch('user/setUserMenu', {});
    await store.dispatch('user/setAsideMenu', {});
  }
})
